module.exports = __webpack_public_path__ + "assets/Circle3Detailed.759a9eaafd50dbe9d64f798dcc6f4fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Circle3Detailed.png
// module id = 481
// module chunks = 0